import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, requiredRole, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem('token');
  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
  const userRole = user ? user.role : null;

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated && (!requiredRole || requiredRole === userRole) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/auth/sign-in',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
